import { defineComponent, // ref,
// watch,
computed, // nextTick,
getCurrentInstance } from "vue";
export default defineComponent({
    components: {},
    props: {
        name: {
            type: String,
            required: true
        },
        versionNum: {
            type: Number,
            required: true
        },
        isHistory: {
            type: Boolean,
            required: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var versionNameLabel = computed(function() {
            return props.isHistory ? root.$t("playTurbo.common.downloadVersionDialog.version.history") : root.$t("playTurbo.common.downloadVersionDialog.version.new");
        });
        var tagType = computed(function() {
            return props.isHistory ? "danger" : "warning";
        });
        return {
            versionNameLabel: versionNameLabel,
            tagType: tagType
        };
    }
});
